import { get } from 'lodash';
import * as Constants from '../../constants';

const resetState = {
  isError: false,
  errors: [],
};
const initialState = {
  ...resetState,
  isLoading: false,
  isAuthSchemeFetchSuccess: false,
};

export default function (state = initialState, action) {
  switch (action.type) {

    case Constants.AUTH_SCHEMES_GET_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        authschemeList: action.payload,
      };
    case Constants.AUTH_SCHEMES_GET_LIST_ERROR:
      return {
        ...state,
        isError: true,
        errors: action.payload,
      };
    default:
      return state;
  }
}

export const getIsLoading = (state) => get(state, 'authSchemes.isLoading');

export const getIsError = (state) => get(state, 'authSchemes.isError');

export const getErrors = state => get(state, 'authSchemes.errors');

export const getAuthSchemesList = (state) => get(state, 'authSchemes.authschemeList.authSchemes');
